import React from 'react'
import ContextProvider from './context/ContextProvider'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import Create from './pages/Create'
import Home from './pages/Home'
import Task from './pages/Task'
import Login from './pages/Login'
import { ClerkLoading, SignedIn, SignedOut } from '@clerk/clerk-react'
import Signup from './pages/Signup'
import RootLayout from './Layout/RootLayout'
import JoinGroup from './pages/JoinGroup'
import ClerkLoader from './components/ClerkLoader'
import Edit from './pages/Edit'
import NotFound from './pages/NotFound'

const App = () => {
  const privateRoutes = createBrowserRouter([
    {
      path: '/',
      element: <Home />,
    },
    {
      path: '/create',
      element: <Create />,
    },
    {
      path: 'tasks/:id',
      element: <Task />,
    },
    {
      path: 'edit/:id',
      element: <Edit />,
    },
    {
      path: 'join-group',
      element: <JoinGroup />,
    },
    {
      path: '*',
      element: <NotFound/>,
    },
  ])
  const publicRoutes = createBrowserRouter([
    {
      path: 'login',
      element: <Login />,
    },
    {
      path: 'signup',
      element: <Signup />,
    },
    {
      path: '*',
      element: <Login />,
    },
  ])
  return (
    <ContextProvider>
      <ClerkLoading>
        <ClerkLoader />
      </ClerkLoading>
      <SignedIn>
        <RootLayout>
          <RouterProvider router={privateRoutes} />
        </RootLayout>
      </SignedIn>
      <SignedOut>
        <RouterProvider router={publicRoutes} />
      </SignedOut>
    </ContextProvider>
  )
}

export default App
